import * as React from "react";
const IconShare = (props) => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.61751 10.4268C9.04289 9.27983 7.85656 8.49243 6.48633 8.49243C4.55333 8.49243 2.98633 10.0594 2.98633 11.9924C2.98633 13.9254 4.55333 15.4924 6.48633 15.4924C7.85656 15.4924 9.04289 14.705 9.61751 13.558M9.61751 10.4268C9.85351 10.8979 9.98633 11.4297 9.98633 11.9924C9.98633 12.5552 9.85351 13.0869 9.61751 13.558M9.61751 10.4268L16.3551 7.05802M9.61751 13.558L16.3551 16.9268M16.3551 7.05802C16.9298 8.20503 18.1161 8.99243 19.4863 8.99243C21.4193 8.99243 22.9863 7.42543 22.9863 5.49243C22.9863 3.55944 21.4193 1.99243 19.4863 1.99243C17.5533 1.99243 15.9863 3.55944 15.9863 5.49243C15.9863 6.0552 16.1191 6.58694 16.3551 7.05802ZM16.3551 16.9268C16.1191 17.3979 15.9863 17.9297 15.9863 18.4924C15.9863 20.4254 17.5533 21.9924 19.4863 21.9924C21.4193 21.9924 22.9863 20.4254 22.9863 18.4924C22.9863 16.5594 21.4193 14.9924 19.4863 14.9924C18.1161 14.9924 16.9298 15.7798 16.3551 16.9268Z"
      stroke="#1C1C2C"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </svg>
);
export default IconShare;
